(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bog-product-stories"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const opener = event.target.closest('[data-bog-story-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.bogStoryOpen);
    if (!dialog) return;
    document.querySelectorAll('.bog-story__video').forEach(video => video.pause());
    dialog.showModal();
    const video = dialog.querySelector('video');
    if (video) video.play().catch(() => {});
    return;
  }
  const close = event.target.closest('[data-bog-story-close]');
  if (close) close.closest('dialog').close();
  if (event.target.matches('.bog-story__dialog')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});
document.addEventListener('close', function(event) {
  if (event.target.matches('.bog-story__dialog')) {
    const video = event.target.querySelector('video');
    if (video) video.pause();
  }
}, true);

  } catch(e) { console.error(e); }
})();
})();
